export const ExternalShipmentContract = {

    async save_with_label(external_shipment_with_label) {
        external_shipment_with_label;

        throw new Error("external_shipments external_shipment_with_label not implemented");
    },

    async get_aff_index_orders(status, page, per_page, ss, sort_by) {
        status;
        page;
        per_page;
        ss;
        sort_by;

        throw new Error("external_shipments get_aff_index_orders not implemented");
    },

    async aff_prepare_orders(ids) {
        ids;

        throw new Error("external_shipments aff_prepare_orders not implemented");
    },

    async aff_scan_identifier(transaction_id, identifier) {
        transaction_id;
        identifier;

        throw new Error("external_shipments aff_scan_identifier not implemented");
    },

    async aff_get_products_by_order(id) {
        id;

        throw new Error("external_shipments aff_get_products_by_order not implemented");
    },

    async aff_get_current_session(transaction_id) {
        transaction_id;

        throw new Error("external_shipments aff_get_current_session not implemented");
    },

    async aff_get_barcode_image(shipment_id) {
        shipment_id;

        throw new Error("external_shipments aff_get_barcode_image not implemented");
    }
}